module.exports = __webpack_public_path__ + "img/eltrebol.428fe820.png";